import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { paintings } from '../data/paintings';
import SafeIcon from '../common/SafeIcon';

const Admin = () => {
  const { t } = useLanguage();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [artworks, setArtworks] = useState(paintings);

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === 'admin') setIsAuthenticated(true);
    else alert('Incorrect password');
  };

  const toggleStatus = (id) => {
    setArtworks(artworks.map(art => 
      art.id === id ? { ...art, available: !art.available } : art
    ));
  };

  const deleteArtwork = (id) => {
    if (window.confirm('Are you sure?')) {
      setArtworks(artworks.filter(art => art.id !== id));
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-gallery-bg">
        <div className="bg-gallery-surface p-8 max-w-md w-full shadow-sm">
          <h1 className="text-2xl font-serif mb-6 text-center">{t('admin.title')}</h1>
          <form onSubmit={handleLogin} className="space-y-6">
            <input 
              type="password" 
              placeholder={t('admin.password')} 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              className="w-full border-b border-gallery-border py-2 focus:outline-none focus:border-gallery-accent bg-transparent" 
            />
            <button 
              type="submit" 
              className="w-full bg-gallery-text text-white py-3 uppercase tracking-widest text-sm hover:bg-gallery-accent transition-colors"
            >
              {t('admin.login')}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-32 pb-20 px-6 max-w-6xl mx-auto">
      <div className="flex justify-between items-center mb-12">
        <h1 className="text-4xl font-serif">{t('admin.title')}</h1>
        <button 
          onClick={() => setIsAuthenticated(false)} 
          className="text-gallery-muted hover:text-gallery-text text-sm uppercase tracking-widest"
        >
          {t('admin.logout')}
        </button>
      </div>

      <div className="bg-gallery-surface shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-gallery-border text-xs uppercase tracking-widest text-gallery-muted">
                <th className="p-4">Image</th>
                <th className="p-4">Title</th>
                <th className="p-4">Price</th>
                <th className="p-4">Status</th>
                <th className="p-4 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {artworks.map(art => (
                <tr key={art.id} className="border-b border-gallery-border hover:bg-gallery-bg/50 transition-colors">
                  <td className="p-4">
                    <img src={art.image} alt={art.title} className="w-16 h-16 object-cover" />
                  </td>
                  <td className="p-4 font-serif">{art.title}</td>
                  <td className="p-4">€{art.price.toLocaleString()}</td>
                  <td className="p-4">
                    <button 
                      onClick={() => toggleStatus(art.id)} 
                      className={`px-3 py-1 text-xs uppercase tracking-wide rounded-full border ${
                        art.available 
                          ? 'border-green-200 bg-green-50 text-green-700' 
                          : 'border-red-200 bg-red-50 text-red-700'
                      }`}
                    >
                      {art.available ? 'Available' : 'Sold'}
                    </button>
                  </td>
                  <td className="p-4 text-right space-x-4">
                    <button 
                      onClick={() => deleteArtwork(art.id)} 
                      className="text-gallery-muted hover:text-red-500 transition-colors"
                    >
                      <SafeIcon name="Trash2" className="w-5 h-5 inline" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="p-6 border-t border-gallery-border bg-gallery-bg/30">
          <button className="flex items-center space-x-2 text-gallery-text hover:text-gallery-accent transition-colors text-sm uppercase tracking-widest">
            <SafeIcon name="Plus" className="w-4 h-4" />
            <span>{t('admin.addArtwork')} (Mock)</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Admin;